import { gql } from "@apollo/client";

export const GET_PROPERTY_GROUPS = gql`
  query {
    property_group {
      id
      name {
        lang
        value
      }
      name_system {
        lang
        value
      }
      step {
        id
        name {
          lang
          value
        }
      }
      type
    }
  }
`;

export const GET_PROPERTY_GROUP = gql`
  query ($id: Int!) {
    property_group(id: $id) {
      id
      name {
        lang
        value
      }
      show_in_page
      name_system {
        lang
        value
      }
      step {
        id
        name {
          lang
          value
        }
      }
      type
      note {
        lang
        value
      }
    }
  }
`;

export const GET_PROPERTY_GROUP_TYPES = gql`
  query ($lang: String!) {
    listType: list(method: "PropertyGroup::listType", lang: $lang) {
      id
      name
    }
  }
`;
